import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useCreatePlaceMutation, useGetCitiesQuery, useGetSportsQuery, useUploadCoverMutation, } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertToCreateDto } from "../common/mappers/convertFromViewModel";
import { getEmptyPlace } from "../common/mappers/getEmptyPlace";
import { PlaceEditForm } from "./components/PlaceEditForm";
export var PlaceCreatePage = function () {
    var _a = useCreatePlaceMutation(), placeCreateAction = _a[0], placeCreateState = _a[1];
    var _b = useUploadCoverMutation(), uploadCoverAction = _b[0], uploadCoverState = _b[1];
    // виды спорта
    var sportsListGetState = useGetSportsQuery({});
    // города
    var citiesListGetState = useGetCitiesQuery({});
    var saveFormHandler = function (data) {
        try {
            placeCreateAction({
                createPlaceDto: convertToCreateDto(data),
            });
            // файлы для загрузки
            var uploadFiles = Array.from(data.coverFiles).filter(function (el) { return el.status === "added"; });
            if (uploadFiles.length) {
                uploadCoverAction({
                    body: {
                        cover: uploadFiles.map(function (el) { return el.file; }),
                        fileIds: uploadFiles.map(function (el) { return el.id; }),
                    },
                });
            }
        }
        catch (err) {
            console.error(err);
        }
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (placeCreateState.isSuccess) {
            navigate(RoutesList.Place.getPlacesList());
        }
    }, [placeCreateState.isSuccess]);
    useSetPageData({ title: "Новая площадка" });
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: uploadCoverState.isLoading ||
                    placeCreateState.isLoading ||
                    sportsListGetState.isLoading ||
                    citiesListGetState.isLoading, loadingKey: "placeCreate" }), sportsListGetState.isSuccess && citiesListGetState.isSuccess && (_jsx(PlaceEditForm, { data: getEmptyPlace(), sportsDict: sportsListGetState.data.items, citiesDict: citiesListGetState.data.items, mode: "create", onSave: saveFormHandler }))] }));
};
